<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você confere as startups selecionadas para participar do
              batch de aceleração Stars. Você, investidor, pode acompanhar com
              detalhes o andamento de cada uma das startups!
            </p>
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div v-if="!empty" class="card-deck vld-parent" ref="startups_list">
            <div
              class="col-lg-4 col-md-6 mb-5 d-flex align-items-stretch"
              v-for="bs in batch.startups"
              :key="bs.startup.user_id"
            >
              <div class="card text-center flex-grow-1">
                <div class="card-profile-image">
                  <img
                    :src="bs.startup.logo.url"
                    class="card-image my-3"
                    alt="..."
                  />
                </div>
                <div class="card-body mt-8 pt-0 pb-0">
                  <h2 class="card-title text-orange mb-1">
                    {{ bs.startup.name }}
                  </h2>
                  <div>
                    <div class="h5 font-weight-300 mb-1">
                      <i class="ni ni-pin-3 mr-2"></i
                      >{{ bs.startup.city || "..." }},
                      {{ bs.startup.state || "..." }}
                    </div>
                    <div class="h5 mt-2">
                      <badge type="info">
                        {{ bs.startup.sector }}
                      </badge>
                    </div>
                    <p class="mt-2 text-sm text-break">
                      <i class="fas fa-quote-left mr-1"></i
                      ><span class="text-muted">{{
                        bs.startup.one_sentence_pitch
                      }}</span
                      ><i class="fas fa-quote-right ml-1"></i>
                    </p>
                  </div>
                </div>
                <div
                  class="card-footer text-center py-3 vld-parent"
                  :ref="`startup_${bs.startup.user_id}`"
                >
                  <base-button
                    type="white"
                    class="text-purple mt-2"
                    :iconOnly="true"
                    icon="fa fa-file-video"
                    title="Ver apresentação da startup"
                    @click="handleOpenStartupPresentation(bs.startup.user_id)"
                  ></base-button>
                  <base-button
                    type="white"
                    class="text-warning mt-2"
                    :iconOnly="true"
                    icon="fa fa-chart-line"
                    title="Ver métricas da startup"
                    @click="handleOpenStartupMetrics(bs.startup.user_id)"
                  ></base-button>
                  <base-button
                    type="white"
                    class="text-default mt-2"
                    :iconOnly="true"
                    icon="fa fa-align-left"
                    title="Ver relatórios qualitativos da startup"
                    @click="handleOpenStartupReports(bs.startup.user_id)"
                  ></base-button>
                  <base-button
                    type="white"
                    class="text-info mt-2"
                    :iconOnly="true"
                    icon="fa fa-chart-pie"
                    title="Ver captable da startup e investimento realizado"
                    @click="handleOpenModalCapitable(bs.startup)"
                  ></base-button>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="row">
            <div class="col-12 text-center">
              <badge type="info" class="bg-white">
                Não existem startups cadastradas no batch até o momento.
              </badge>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      :show.sync="modalCapitable.show"
      modal-classes="modal-dialog-centered"
      header-classes="pb-1"
      body-classes="pb-0"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Capitable e investimento
      </h6>
      <div class="text-center">
        <i class="fa fa-chart-pie fa-3x"></i>
        <h4 class="mt-3 text-warning">{{ modalCapitable.startup.name }}</h4>
      </div>
      <div class="mt-4" v-if="modalCapitable.startup.cards">
        <CustomCardList
          :data="modalCapitable.startup.cards"
          :showHeader="false"
          size="col-12"
        />
      </div>
      <div slot="footer">
        <base-button type="white" @click="modalCapitable.show = false">
          Fechar
        </base-button>
      </div>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api";

import CustomCardList from "@/components/CustomCardList";

export default {
  name: "startups_list_batch",
  components: {
    CustomCardList,
  },
  data() {
    return {
      batch: "",
      empty: false,
      modalCapitable: {
        show: false,
        startup: "",
      },
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.startups_list,
      width: 150,
      height: 150,
      color: "#ffffff",
      backgroundColor: "transparent",
    });
    this.loadStartups();
    loader.hide();
  },
  methods: {
    async loadStartups() {
      try {
        const { data } = await api.get(
          `/investor-batches/${this.$route.params.id}`
        );
        if (data) this.batch = data;
        if (data.startups) {
          const defaultLogoPath = "/img/pages/default_logo.png";
          data.startups.forEach((bs) => {
            if (!bs.startup.logo) bs.startup.logo = { url: defaultLogoPath };
          });
        } else {
          this.empty = true;
        }
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao recuperar as startups do batch"
        );
        this.$router.push("/investidor/batches");
      }
    },
    handleOpenStartupPresentation(startupId) {
      this.$router.push(
        `/investidor/batches/${this.$route.params.id}/startup/${startupId}/apresentacao`
      );
    },
    handleOpenStartupMetrics(startupId) {
      this.$router.push(
        `/investidor/batches/${this.$route.params.id}/startup/${startupId}/acompanhamento`
      );
    },
    handleOpenStartupReports(startupId) {
      this.$router.push(
        `/investidor/batches/${this.$route.params.id}/startup/${startupId}/relatorios`
      );
    },
    async handleOpenModalCapitable(startup) {
      if (!startup.cards) {
        const loader = this.$loading.show({
          container: this.$refs[`startup_${startup.user_id}`][0],
          width: 50,
          height: 50,
        });
        try {
          const { data: cards } = await api.get(
            `/investor-batch-startup/${this.$route.params.id}/startups/${startup.user_id}/cards?capitable_related=true`
          );
          loader.hide();
          if (cards.length) {
            startup.cards = cards;
          } else {
            this.$toasted.error("Nenhuma informação para exibição no momento");
            return;
          }
        } catch (e) {
          loader.hide();
          this.$toasted.error("Ocorreu um erro ao carregar as informações");
          return;
        }
      }
      this.modalCapitable.startup = startup;
      this.modalCapitable.show = true;
    },
  },
};
</script>
<style scoped>
.card-image {
  width: 140px;
  height: 140px;
  border-radius: 10%;
  margin: auto;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
